import { Extension } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { SlashItemProps, SlashItemsProps } from './slashCommand.types';
import { slashMenuMappings } from './slashMenuMappings';
import { SlashMenuType } from './slashMenuTypes';
import { handleSlashCommand } from './slashCommandActions';
import { createSlashCommandRender } from './slashCommandRender';

const SlashCommand = Extension.create({
  name: 'slash-command',

  addOptions() {
    return {
      suggestion: {
        char: '/',
        command: handleSlashCommand,
        items: ({
          query
        }: SlashItemsProps): SlashItemProps[] | Promise<SlashItemProps[]> => {
          return (Object.keys(slashMenuMappings) as SlashMenuType[])
            .map(type => ({
              title: slashMenuMappings[type].label,
              type,
              icon: slashMenuMappings[type].icon
            }))
            .filter(item =>
              item.title.toLowerCase().includes(query.toLowerCase())
            );
        },
        render: createSlashCommandRender
      }
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        ...this.options.suggestion,
        editor: this.editor
      })
    ];
  }
});

export default SlashCommand;
